import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const generateOffer = {
    namespaced: true,
    state: {
        operation: ""
    },
    mutations: {
        GET_OFFER_PDF_SUCCESS(state, response) {
            eventBus.$emit("operationOffer", response.data, state.operation);
        },
        GET_OFFER_PDF_FAILURE(state, error) {
            if (error.response.data.errors.type && error.response.data.errors.type[0] === 'diskLimitExceeded') {
                eventBus.$emit('generateOfferPdfFailed');
                eventBus.$emit('projectDiskLimitExceeded', error.response.data.errors);
            } else {
                let dataReceive = {
                    title: error.response.data.message,
                    message: handleError(error) !== "" ? handleError(error) : error.response.data.data.message
                }
                eventBus.$emit("operationFailure", dataReceive);
            }
            
        }
    },
    actions: {
        getOfferPdf: function({ dispatch, state }, payload) {
            var promise = sendRequest("get", config.baseURLApi + "/offers/" + payload.creds.id + "/generate-offer-pdf");
            state.operation = payload.creds.operation;
            promise.then(function(result) {
                if(result[0] === "success") {
                    result[1].data.id = payload.creds.id;
                    dispatch("successGetOfferPdf", result[1]);
                } else {
                    dispatch("failureGetOfferPdf", result[1]);
                }
            })
        },
        successGetOfferPdf: function({ commit }, response) {
            commit("GET_OFFER_PDF_SUCCESS", response);
        },
        failureGetOfferPdf: function({ commit }, error) {
            commit("GET_OFFER_PDF_FAILURE", error);
        },
    }
}

export default generateOffer;
